import { CheckCircle, Target, Users, Shield, Clock, BookOpen, HelpCircle, Star } from "lucide-react";

const benefits = [
  {
    description: "O programa completo dos 8 Pilares para reconstruir sua mente por inteiro",
    icon: <CheckCircle />,
  },
  {
    description: "Trilhas práticas semana a semana para aplicar tudo na vida real",
    icon: <Target />,
  },
  {
    description: "Exercícios guiados para eliminar recaídas e fortalecer seu controle",
    icon: <Users />,
  },
  {
    description: "Reprogramações emocionais para reduzir ansiedade e estabilizar sua rotina",
    icon: <Shield />,
  },
  {
    description: "Aulas específicas para reorganizar suas emoções e seus gatilhos",
    icon: <Clock />,
  },
  {
    description: "Orientações para recuperar seu foco, seu dinheiro e sua rotina",
    icon: <BookOpen />,
  },
  {
    description: "Suporte estruturado para manter você firme durante todo o processo",
    icon: <HelpCircle />,
  },
  {
    description: "O método premium que já tirou pessoas do fundo do poço e devolveu estabilidade, clareza e confiança",
    icon: <Star />,
  },
];

export const Benefits = () => {
  return (
    <section className="pb-20 relative">
      <div className="container px-4">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            O que você vai ter{" "}
            <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
              acesso
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Glass card */}
              <div className="relative h-full backdrop-blur-xl bg-card/40 rounded-2xl p-6 border border-primary/20 hover:border-primary/40 transition-all duration-500 hover:shadow-[0_8px_32px_rgba(100,192,242,0.2)] hover:-translate-y-2">
                {/* Icon */}
                <div
                  className="w-14 h-14 rounded-xl mb-4 group-hover:scale-110 shadow-lg transition-transform duration-300 flex items-center justify-center bg-gradient-accent">
                  {benefit.icon}
                </div>

                {/* Content */}
                <p className="text-muted-foreground">{benefit.description}</p>

                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-radial from-primary/10 via-transparent to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
